import { store } from '../store';
import { logout } from '../store/slices/authSlice';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = {
    async post(endpoint: string, data: any) {
        // With cookie-based authentication, no need to check token expiration
        // The server will validate the session cookie automatically

        const response = await fetch(`${apiUrl}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            credentials: 'include', // Send cookies for session auth
        });

        if (!response.ok) {
            if (response.status === 401) {
                store.dispatch(logout());
                window.location.href = '/login';
            }
            const errorData = await response.json();
            throw new Error(errorData.message || 'An error occurred');
        }

        return response.json();
    },

    async get(endpoint: string) {
        const response = await fetch(`${apiUrl}${endpoint}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include', // Send cookies for session auth
        });

        if (!response.ok) {
            if (response.status === 401) {
                store.dispatch(logout());
                window.location.href = '/login';
            }
            const errorData = await response.json();
            throw new Error(errorData.message || 'An error occurred');
        }

        return response.json();
    },

    async put(endpoint: string, data: any) {
        const response = await fetch(`${apiUrl}${endpoint}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
            credentials: 'include', // Send cookies for session auth
        });

        if (!response.ok) {
            if (response.status === 401) {
                store.dispatch(logout());
                window.location.href = '/login';
            }
            const errorData = await response.json();
            throw new Error(errorData.message || 'An error occurred');
        }

        return response.json();
    },

    async delete(endpoint: string) {
        const response = await fetch(`${apiUrl}${endpoint}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include', // Send cookies for session auth
        });

        if (!response.ok) {
            if (response.status === 401) {
                store.dispatch(logout());
                window.location.href = '/login';
            }
            const errorData = await response.json();
            throw new Error(errorData.message || 'An error occurred');
        }

        return response.json();
    },
};

export default api;